import React from 'react';
import AppProviders from 'providers/app-providers';

export const wrapRootElement = ({ element }) => (
  <AppProviders>{element}</AppProviders>
);
